<template>
  <div class="notification-single">
    <div class="container">
      <div class="notification-content">
        <div class="notification-header">
          <h1>{{notification.friendly_subject}}</h1>
          <span class="time">recebido em {{notification.created_at_friendly}}</span>
        </div>

        <div class="content" v-if="notification.key == 'lobby.schedule'">
          <h1>Você tem um jogo agendado</h1>
          <p>
            A equipe
            <router-link
              v-if="notification.lobby && notification.lobby.team_a"
              :to="{ name: 'TeamSingle', params: { id: notification.lobby.team_a.to_param }}"
            >{{notification.lobby.team_a.name}}</router-link>
agendou um jogo com o seu time
            <router-link
              v-if="notification.lobby && notification.lobby.team_b"
              :to="{ name: 'TeamSingle', params: { id: notification.lobby.team_b.to_param }}"
            >{{notification.lobby.team_b.name}}</router-link>
          </p>

          <p>A partida estará disponível para todos os jogadores na página inicial do QUEOTA.club: {{notification.lobby.start_time_friendly}}.</p>

          <h4 class="subtitle">
            Data/Hora:
            <strong>{{notification.lobby.start_time_friendly}}</strong>
          </h4>
          <h4 class="subtitle">
            Mapa:
            <strong>{{notification.lobby.map}}</strong>
          </h4>
          <h4 class="subtitle">
            Tamanho do Lobby:
            <strong>{{notification.lobby.players_per_team}}x{{notification.lobby.players_per_team}}</strong>
          </h4>

          <div v-if="!notification.lobby.accepted">
            <b-btn
              variant="success"
              size="lg"
              @click="acceptMatch(notification.lobby.id)"
            >Aceitar jogo</b-btn>
            <br>
            <small>para rejeitar basta ignorar essa mensagem</small>
          </div>
          <div v-else>já foi aceito pelo seu time</div>
        </div>

        <div v-if="notification.key == 'lobby.fightback'">
          <h3>
            Replay da Partida
            <strong>by FIGHTBACK.club</strong>
          </h3>
          <p>Em parceria com o FIGHTBACK.club, você pode visualizar o replay de sua partida aqui pelo site.</p>
          <p>
            <router-link
              class="btn btn-success btn-lg"
              :to="{ name: 'LobbySingle', params: { id: notification.lobby.id }}"
            >assistir agora</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass">
.notification-single
  .container
    .notification-content
      background: rgba(255, 255, 255, .02)
      border-left: 1px solid rgba(255, 255, 255, .02)
      border-right: 1px solid rgba(255, 255, 255, .02)
      border-bottom: 1px solid rgba(255, 255, 255, .02)
      border-bottom-left-radius: 4px
      border-bottom-right-radius: 4px
      padding: 20px

      .notification-header
        padding: .5em 0 2em
        text-align: center
        margin: .5em 0 2em

      .content
        @media (max-width: 600px)
          img
            width: 100% !important
            height: auto !important
</style>


<script>
export default {
  name: "NotificationSingle",
  data() {
    return {
      notification: {}
    };
  },
  metaInfo() {
    return {
      title: `${this.notification.friendly_subject}`
    };
  },
  methods: {
    initialize() {
      this.$http
        .get("notifications/" + this.$route.params.id + ".json")
        .then(response => {
          this.notification = response.data;
          this.$store.dispatch(
            "updateNotificationsCount",
            response.data.unread_count
          );
        });
    },
    acceptMatch(lobby_id) {
      this.$http.get(`lobbies/${lobby_id}/accept.json`).then(response => {
        this.$notify({
          group: "all",
          title: response.data.message
        });
        this.lobby.accepted = true;
      });
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
    "$route.params.id": function(id) {
      this.initialize();
    }
  }
};
</script>
